import Motassign from './Motassign'

export default Motassign
